import Vue from 'vue'
import VueRouter from 'vue-router'
import ViewHome from '../views/ViewHome.vue'
import ViewPage from '../views/ViewPage.vue'
import ViewClient from '../views/ViewClient.vue'
import ViewCatalog from '../views/ViewCatalog.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: ViewHome,
    meta: { transition: 'fade-in-up' }
  },
  {
    path: '/client/:slug',
    name: 'client',
    component: ViewClient,
    meta: { transition: 'fade-in-up' }
  },
  {
    path: '/catalogi/:slug',
    name: 'catalog',
    component: ViewCatalog,
    meta: { transition: 'fade-in-up' }
  },
  {
    path: '/:slug',
    name: 'page',
    component: ViewPage,
    meta: { transition: 'fade-in-up' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
